import { QueryResponse } from '@common/types/queryState';
import { Box, Grid, Skeleton } from '@radix-ui/themes';

export interface CollectionItem {
    id: string;
}

export interface ExtendedCollectionsUIProps<T extends CollectionItem>
    extends QueryResponse<T> {
    // PaginationControls
    isLoading: boolean;
    renderItem: (item: T) => React.ReactNode;
}

export const ExtendedCollectionsUI = <T extends CollectionItem>({
    data,
    isLoading,
    renderItem,
}: ExtendedCollectionsUIProps<T>) => {
    return (
        <Grid columns={'10'} gap={'4'} px={'6'} py={'2'}>
            {data.map((item) => (
                <Skeleton key={item.id} loading={isLoading}>
                    <Box
                        style={{
                            flexShrink: 0,
                            scrollSnapAlign: 'start',
                        }}
                    >
                        {renderItem(item)}
                    </Box>
                </Skeleton>
            ))}
        </Grid>
    );
};
